import React, { useContext } from "react";

import { EventContext, LookupContext } from "@gp/components";
import { Team } from "@gp/models";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { MobilePlatform } from "@state/stores/types";
import { THEME_SETTINGS } from "@theme-settings";
import { analyticsTracker } from "@utils/analytics";
import classNames from "classnames";
import { observer } from "mobx-react";

export const FavoritesButton = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function FavoritesButton(props: {
			isOfferButton?: boolean;
			isSmallIcon?: false;
		}) {
			const { isOfferButton = false } = props;

			const event = useContext(EventContext);
			const rootStore = useRootAppStore<MobilePlatform>();
			const offerOptions = useOfferOptionsContext();

			const favoriteStore = useContext(FavoritesStoreContext);

			const lookupContext = useContext(LookupContext);

			if (!favoriteStore || offerOptions.isOfferHistory) {
				return null;
			}

			let t1: Team | undefined, t2: Team | undefined;

			t1 = lookupContext.teams.get(event.teamOneId || "");
			t2 = lookupContext.teams.get(event.teamTwoId || "");

			let tournament = lookupContext.tournaments.get(event.tournamentId);
			let sport = lookupContext.sports.get(event.sportId);
			const isFavorite = favoriteStore.userFavoriteEventsSet.has(
				event.id
			);

			function toggleFavorites(e: React.MouseEvent<HTMLButtonElement>) {
				e.persist();
				if (!rootStore.userAuthStore.isLoggedIn) {
					rootStore.favoritePopupStore.activatePopup();
					return;
				}
				if (isFavorite) {
					favoriteStore.removeUserFavoriteEvent(event.id);
				} else {
					favoriteStore.addUserFavoriteEvent(event.id);
					analyticsTracker.trackEventFavorited(
						event.id,
						t1?.abrv || "",
						t2?.abrv || "",
						tournament?.abrv || "",
						sport?.abrv || ""
					);
				}
			}

			//#region css classes

			const buttonClasses = classNames(
				"at-actionFav",
				{
					match__details__btn: isOfferButton,
					event__top__btn: !isOfferButton,
				},
				"btn",
				{
					"btn--square--reset btn--ghost": isOfferButton,
					"btn--square btn--square--sml btn--ghost": !isOfferButton,
				}
			);

			const iconClasses = classNames(
				{
					match__details__icon: isOfferButton,
					event__actions__icon: !isOfferButton,
				},
				"u-icon",
				{
					"u-icon--xsml": isOfferButton,
					"u-icon--sml": !isOfferButton,
					"u-icon--star--str u-color--sent--warning": isFavorite,
					"u-icon--star--alt": !isFavorite,
					"u-color--sent--muted":
						!isFavorite &&
						(event.isOutright ||
							!rootStore.userAuthStore.isLoggedIn),
				}
			);
			//#endregion css classes

			return (
				<button
					className={buttonClasses}
					type="button"
					onClick={toggleFavorites}
					disabled={event.isOutright}
				>
					<i className={iconClasses} />
				</button>
			);
		});
